// 通用文本翻译

export const common = {
    loading: '加载中...',
    back: '返回',
    download: '下载',
    loadMore: '加载更多',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    submit: '提交',
    close: '关闭',
    yes: '是',
    no: '否',
    ok: '确定',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '信息',
    retry: '重试',
    reset: '重置'
  };
